export default __webpack_public_path__ + "static/media/Lip_11_F.754cc888.svg";